import { Navigate } from 'react-router-dom';

import { NBA_PLAY } from '@sorare/core/src/constants/__generated__/routes';

const GamePage = () => {
  return <Navigate to={NBA_PLAY} replace />;
};

export default GamePage;
